// config
// chest
// startValue

G.PFEventPanelChest = function(config) {
  this.chest = config.chest;

  var stars = G.saveState.getAllStars();

  config.valueTarget = Math.min(this.chest.req, stars);
  config.value = config.startValue === undefined ? config.valueTarget : config.valueTarget;
  config.target = this.chest.req;
  config.progressBar = {};

  G.PFEventPanel.call(this, config);

  this.desc = this.add(new G.Text(0, -20, OMT.language.getText("Stars Collected"), {
    style: "font-white",
    fontSize: 25,
  }, 0.5, 200));

  this.starIcon = G.makeImage(-161, 4, "star", 0.5, this);
  this.starIcon.scale.setTo(0.5);
  this.chestIcon = G.makeImage(160, 2, "chest_full", 0.5, this);
  this.chestIcon.scale.setTo(0.8);
};

G.PFEventPanelChest.prototype = Object.create(G.PFEventPanel.prototype);

